// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dmjP","col":"styles_col__ftzDe"};